<header message="{{ 'LOGIN.WELCOME' | translate:locale.language }}"></header>
<div class="occon-login-body">
  <div class="occon-login-columns animated fadeInDown">
    <div class="row white-bg occon-login-panel">
      <div class="login-panel-part">
        <div class="occon-login-info" style="height: 100%">
          <div class="occon-login-support" style="flex: 1">
            <div class="occon-login-password-message" *ngIf="!expiredToken">
              {{'LOGIN.RESET_PASSWORD_TITLE' | translate:locale.language}}
            </div>
            <div *ngIf="expiredToken" class="color-occon-red-mid token-expired">
              <span><fa-icon size="2x" icon="exclamation-triangle"></fa-icon></span>
              <span><strong style="color: white">{{'LOGIN.MESSAGES.RESET_TOKEN_EXPIRED_TITLE' | translate:locale.language}}</strong></span>
              <span><strong style="color: white">{{'LOGIN.MESSAGES.RESET_TOKEN_EXPIRED_TEXT' | translate:locale.language}}</strong></span>
            </div>
          </div>
        </div>
      </div>
      <div class="login-part-separator">
        <div class="separator-left"></div>
        <div class="separator-right"></div>
        <div class="login-icon">
          <div class="outer">
            <fa-icon size="2x" icon="sign-in-alt"></fa-icon>
          </div>
        </div>
      </div>
      <div class="login-panel-part">
        <div class="password-reset-card">
          <div *ngIf="newPassword.length != 0 && !validatePasswordRegex(newPassword)" class="color-occon-red-mid">
            <span><strong>{{ 'REGISTRATION.ERRORMESSAGE.PASSWORD_WEAK' | translate:locale.language }}</strong></span>
          </div>
          <div class="label-and-input">
            <label for="new_password">{{ "REGISTRATION.PASSWORD_NEW" | translate:locale.language }}:</label>
            <input [disabled]="expiredToken" type="password" class="form-control" id="new_password" [(ngModel)]="newPassword">
          </div>
          <div>
            <label for="confirm_password">{{ "REGISTRATION.PASSWORD_CONFIRM" | translate:locale.language }}:</label>
            <input [disabled]="expiredToken" type="password" class="form-control" id="confirm_password" [(ngModel)]="confirmPassword">
          </div>
          <password-strength-bar [passwordToCheck]="newPassword"></password-strength-bar>
          <button class="btn btn-success"
                  [disabled]="!newPassword || !confirmPassword || newPassword !== confirmPassword || !validatePasswordRegex(newPassword)"
                  (click)="savePassword()">
            {{ "REGISTRATION.PASSWORD_SAVE" | translate:locale.language }}
          </button>
          <button style="width: 100%; margin-top: 10px" class="btn btn-default" (click)="backToLogin()">
            {{'REGISTRATION.NAVIGATION.MAINPAGE' | translate:locale.language}}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<footer></footer>
